<script setup>
    import Action from '@/Pages/Toolkit/Partials/Action.vue';

    const props = defineProps({
        toolkit: Object,
        team: Object,
        actions: Array,
        loggedInUserId: Number,
        currentToolkitTeamUsers: Array,
        auditor: Boolean,
        auditorSession: Object,
        adminAudit: Boolean,
        pastToolkit: Boolean,
        currentActiveToolkit: Boolean,
        adminToolkit: Boolean,
        adminInfo: Object,

        filters: Object,
    });

    const emit = defineEmits(['statusChanged']);

    const statusChanged = (action, status) => {
        emit('statusChanged', action, status);
    };

</script>

<template>
    <Action v-for="action in actions" :toolkit="toolkit" :team="team" :currentToolkitTeamUsers="currentToolkitTeamUsers" :action="action" :loggedInUserId="loggedInUserId" :auditor="auditor" :auditorSession="auditorSession" :adminAudit="adminAudit" :pastToolkit="pastToolkit" :adminToolkit="adminToolkit" :adminInfo="adminInfo" :currentActiveToolkit="currentActiveToolkit" :filters="filters" @statusChanged="statusChanged" />
</template>
